import { UploadFileOutlined } from "@mui/icons-material";
import { Button, Typography, styled } from "@mui/material";
import { getCsvContent } from "../lib/format";
import { downloadCsv } from "../lib/helper";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function UploadCSVButton<T>(props: {
  label?: string;
  onChange: (data: T[]) => void;
  keys: (keyof T)[];
  sample: string;
}) {
  const { onChange, keys, sample, label } = props;

  const onUpload = async (e: any) => {
    try {
      const _members = await getCsvContent<T>(e.target.files[0], keys);
      if (_members.length > 0) {
        onChange(_members);
      }
    } catch (error: any) {
      window.webApp.showMessage(
        "error",
        `Error happened: ${error?.message || error}`,
      );
    }
    e.target.value = "";
  };

  const onDownloadSample = () => {
    downloadCsv("sample", sample);
  };
  return (
    <>
      <Button
        variant="contained"
        component="label"
        className="initial-text width-100p"
        startIcon={<UploadFileOutlined />}
      >
        {label || "Import by csv"}
        <VisuallyHiddenInput
          type="file"
          accept=".csv, text/csv"
          onChange={onUpload}
        />
      </Button>
      <Typography
        color="primary"
        className="margin-t-normal pointer"
        onClick={onDownloadSample}
      >
        Download sample csv file
      </Typography>
    </>
  );
}
